export default __webpack_public_path__ + "static/media/calendar-icon.234a9a1c.svg";